// ************************
// // src/app/agendexCliente/components/Footer/footer.js
// autor: W de Paula/IA 
// data: 3/7/24 : 13h47
// objetivo: mostrar no rodapé de todas as páginas as redes sociais da aplicação
// data: 4/10/25 | 20h20 | não estava mostrando os ícones do fontwasome. modificamos para as do bootstrap
// *********************

// autologout.js


import logoWMX from '../../../../Assets/WMXGroup/wmx466px167p.png';
import './footer.css';

function Footer(){
    var ano = new Date().getFullYear();
    
    return<>
    <div className="container">
        <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
            <div className="col-md-8 d-flex align-items-center">
                <a href="/" className="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1">
                    <img src={logoWMX} alt="WMX Group" className='img'/>
                </a>
                <span className="mb-3 mb-md-0 text-body-secondary">&copy; 2021 - {ano} | Microvolution Informática</span>
            </div>

            <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
                <li className="list-inline-item">
                    <a href="https://facebook.com/profile.php?id=61559047367989" target="_blank" rel="noreferrer">
                    <i className="bi bi-facebook fs-4"></i></a>
                </li>
                <li className="list-inline-item">
                    <a href="https://instagram.com/_agendex" target="_blank" rel="noreferrer">
                    <i className="bi bi-instagram fs-4"></i></a>
                </li>						
                <li className="list-inline-item">
                    <a href="https://youtube.com/microvolution" target="_blank" rel="noreferrer">
                    <i className="bi bi-youtube fs-4"></i></a>
                </li>
                <li className="list-inline-item">
                    <a href="https://www.microvolution.wmx.net.br" target="_blank" rel="noreferrer">
                    <i className="bi bi-link fs-4"></i></a>
                </li>
                <li className="list-inline-item">
                    <a href="mailto:microvolution.informatica@gmail.com" target="_blank" rel="noreferrer">
                    <i className="bi bi-envelope fs-4"></i>
                    </a>
                </li>
            </ul>
        </footer>
    </div>
</>
}

export default Footer;